import React from 'react'
import Lang from '@components/Lang/Lang'
import { Tabs, Badge,} from 'antd'
import CommonBreadcrumb from "@components/CommonBreadcrumb"
import WaitWarehouseTable from "@pages/WarehouseManagement/component/Registration/WaitWarehouseTable";
import IntoWarhouseTable from "../component/Registration/IntoWarhouseTable";
import ClearanceTable from "../component/Registration/ClearanceTable"

class Registration extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            waitIntoNum: "",
            waitIntoWarehouseCount:"",
            tabKay: 'wait',
        }
        this.intoWarehouseRef = React.createRef();
        this.waitWarehouse = React.createRef() ;
    }

    tabsOnChange(key) {
        this.setState({
            tabKay: key,
        },() => {
            // console.log(this.state.tabKay);
        })
    }
    changeNum(waitIntoWarehouseCount,waitIntoNum){
        this.setState({
            waitIntoWarehouseCount,
            waitIntoNum
        })
    }
    render() {
        let tabKey = this.state.tabKay
        return (
            <div>
                <CommonBreadcrumb list={[
                    {name: Lang({id: 'RuKuDengJi', default: '入库登记'})},
                ]}></CommonBreadcrumb>
                <div className="customer-screen">
                    <Tabs defaultActiveKey="clearance" onChange={this.tabsOnChange.bind(this)}
                          items={[ {
                              key: 'clearance',
                              label:(<div>
                                    <span className="mr_4">
                                            {Lang({id: 'YiQingGuanWeiRuKu', default: '已清关未入库'})}
                                    </span>
                                  <Badge count={this.state.waitIntoWarehouseCount}></Badge>
                              </div>),
                              children:<ClearanceTable changeNum={(waitIntoWarehouseCount,waitIntoNum) =>this.changeNum(waitIntoWarehouseCount,waitIntoNum)} />
                          },
                              {
                                  key: 'wait',
                                  label:(<div>
                                    <span className="mr_4">
                                            {Lang({id: 'DaiRuKu', default: '待入库'})}
                                    </span>
                                      <Badge count={this.state.waitIntoNum}></Badge>
                                  </div>),
                                  children:<WaitWarehouseTable ref={this.waitWarehouse}
                                                               changeNum={(waitIntoWarehouseCount,waitIntoNum) =>this.changeNum(waitIntoWarehouseCount,waitIntoNum)}
                                      />
                              },
                              {
                                  key: 'into',
                                  label:Lang({id: 'YiRuKu', default: '已入库'}),
                                  children:<IntoWarhouseTable ref={this.intoWarehouseRef} />
                              }
                          ]}
                    >
                    </Tabs>
                </div>
            </div>
        )
    }
}

export default Registration
